import { Component, Input } from '@angular/core';
import { ChartDataset, ChartType, ChartOptions } from 'chart.js';
import { InformeVentas } from '../../../models/booking-reports.model';

@Component({
    selector: 'app-sales-report',
    templateUrl: './sales-report.component.html',
    styleUrls: ['./sales-report.component.scss'],
    standalone: false
})
export class SalesReportComponent {
  @Input() data: InformeVentas | null = null;

  get hasRecords(): boolean {
    return this.data != null && this.data.filas.length > 0;
  }

  get salesChartLabels(): string[] {
    return this.data ? this.data.resumenPorEmpleado.map(e => e.nombreEmpleado) : [];
  }

  get salesChartData(): ChartDataset<'bar'>[] {
    return [
      {
        data: this.data ? this.data.resumenPorEmpleado.map(e => e.ventasTotales) : [],
        label: 'Ventas (€)',
        backgroundColor: '#e3fd64',
        borderColor: '#4d4e56',
        borderWidth: 1
      }
    ];
  }

  salesChartType: ChartType = 'bar';

  salesChartOptions: ChartOptions<'bar'> = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        beginAtZero: true
      }
    }
  };

  trackByRow(index: number, row: any): string {
    return row.citaId;
  }

  trackByEmployee(index: number, summary: any): string {
    return summary.empleadoId;
  }
}